import { useAtomValue } from "jotai";
import { messagesAtom } from "../constants/budget-atom";
import { useEffect, useRef } from "react";

const BudgetChatQuery: React.FC<{
  query: string[];
}> = ({ query }) => {
  return (
    <div className="ml-16 flex flex-wrap self-end rounded-3xl bg-secondary p-4 font-poppins text-sm">
      {query.map((topic, index) => (
        <div key={index} className="flex flex-row">
          <span>{topic}</span>
          {index !== query.length - 1 && <span className="mr-1">{", "}</span>}
        </div>
      ))}
    </div>
  );
};

export default BudgetChatQuery;
